import { useCallback } from 'react';
import { getDirectParentFromBreadcrumbs } from '../../../utils/breadcrumbs';
const createCategoryFromParent = (category) => ({
    id: category.parentId,
    name: getDirectParentFromBreadcrumbs(category.breadcrumbs) ?? '',
    isVertical: false,
    breadcrumbs: category.breadcrumbs.slice(0, -1),
    children: category.children,
    allowSelection: category.allowSelection,
});
export const useCategoryNavigation = ({ selectedCategory, parentCategory, onSelect, }) => {
    const navigateUp = useCallback(() => {
        if (!selectedCategory)
            return;
        if (!selectedCategory.parentId) {
            onSelect(undefined);
            return;
        }
        if (selectedCategory.children.length > 0) {
            onSelect(createCategoryFromParent(selectedCategory));
            return;
        }
        if (parentCategory?.parentId) {
            onSelect(createCategoryFromParent(parentCategory));
            return;
        }
        onSelect(undefined);
    }, [selectedCategory, parentCategory, onSelect]);
    const navigateDown = useCallback((category) => {
        onSelect(category);
    }, [onSelect]);
    return {
        navigateUp,
        navigateDown,
    };
};
